export default class User {
  store = null;
  accountData = null;
  props = {
    'id': null,
    'fullName': null,
    'login': null,
    'securityPin': null,
    'authTokenAcquired': null,
    'twoFAVerification': null,
    'csrf': null,
    'loggedIn': false
  };

  constructor(store, userProps) {
    this.store = store;
    this.patch(userProps);
  }

  refreshToken(csrf, authTokenAcquired) {
    this.patch(this.props, {
      'csrf': csrf,
      'authTokenAcquired': authTokenAcquired
    });
    localStorage.setItem('csrf', csrf);
    localStorage.setItem('authTokenAcquired', JSON.stringify(authTokenAcquired));
    return this;
  }

  logIn(csrf, authTokenAcquired) {
    this.logOut();
    Object.assign(this.props, {
      'csrf': csrf,
      'authTokenAcquired': authTokenAcquired,
      'loggedIn': true
    });
    if (!this.get('twoFAVerification') && localStorage.getItem('2FAVerification')) {
      this.patch({'twoFAVerification': JSON.parse(localStorage.getItem('2FAVerification'))});
      localStorage.removeItem('2FAVerification');
    }
    if (!this.get('securityPin') && localStorage.getItem('securityPin')) {
      this.patch({'securityPin': localStorage.getItem('securityPin')});
      localStorage.removeItem('securityPin');
    }
    localStorage.setItem('csrf', csrf);
    localStorage.setItem('authTokenAcquired', JSON.stringify(authTokenAcquired));
    this.store._persist();
    return this;
  }

  logOut() {
    this.store.getAll().forEach(user => {
      user
        .set('loggedIn', false)
        .set('authTokenAcquired', null)
        .set('csrf', null);
    });
    this.accountData = null;
    localStorage.removeItem('csrf');
    localStorage.removeItem('authTokenAcquired');
    this.store._persist();
    return this;
  }

  setAccountData(account) {
    if (typeof account === 'object' && account.hasOwnProperty('id')) {
      this.accountData = account;
    }
    //update persisted props too
    this.patch(this.accountData);
    return this;
  }

  getAccountData() {
    return this.accountData;
  }

  getServerKey() {
    return this.accountData ? this.accountData.serverKey : null;
  }

  getSecurityPin() {
    return this.get('securityPin');
  }

  patch(userProps) {
    Object.keys(userProps).forEach(prop => {
      if (this.props.hasOwnProperty(prop)) {
        this.props[prop] = userProps[prop];
      }
    });
    return this;
  }

  get(propName) {
    return this.props.hasOwnProperty(propName) ? this.props[propName] : undefined;
  }

  set(propName, value) {
    if (this.props.hasOwnProperty(propName)) {
      this.props[propName] = value;
    }
    this.store._persist();
    return this;
  }

  export() {
    return this.props;
  }

  remove() {
    this.store.remove(this.get('id'));
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/class/User.js